module.exports = __webpack_public_path__ + "static/media/al_bg_2.04ce7b8e.png";